import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check--primary-no-padding",
  "use": "check--primary-no-padding-usage",
  "viewBox": "0 0 17 12",
  "content": "<symbol viewBox=\"0 0 17 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check--primary-no-padding\"><path d=\"M14.5.7 6.02 9.18 2.48 5.64a.996.996 0 1 0-1.41 1.41l4.24 4.24c.39.39 1.02.39 1.41 0l9.18-9.18a.999.999 0 0 0-.01-1.42c-.37-.38-1-.38-1.39.01Z\" fill=\"#003595\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol